/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FacetData } from '../models/facet-data';
import { getFacetData } from '../fn/facet-data/get-facet-data';
import { GetFacetData$Params } from '../fn/facet-data/get-facet-data';


/**
 * API for retrieving Facet Data
 */
@Injectable({ providedIn: 'root' })
export class FacetDataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFacetData()` */
  static readonly GetFacetDataPath = '/api/facet';

  /**
   * Retrieve facet data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacetData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacetData$Response(params?: GetFacetData$Params, context?: HttpContext): Observable<StrictHttpResponse<FacetData>> {
    return getFacetData(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve facet data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacetData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacetData(params?: GetFacetData$Params, context?: HttpContext): Observable<FacetData> {
    return this.getFacetData$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacetData>): FacetData => r.body)
    );
  }

}
